var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open_sumsub_container),expression:"open_sumsub_container"}],attrs:{"id":"sumsub-websdk-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }